import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';
import { CHAT_MAIN_COLUMN_CLASS } from 'constant/chat-layout';

interface ConversationUnavailableProps {
  backTo?: string;
  className?: string;
}

export function ConversationUnavailable({
  backTo = '/chat',
  className,
}: ConversationUnavailableProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      className={`flex w-full flex-1 flex-col items-center justify-center min-h-[calc(100vh-12rem)] px-6 ${className ?? ''}`}
    >
      <div
        className={`flex flex-col items-center gap-4 rounded-xl border border-dashed border-border/70 px-8 py-14 text-center ${CHAT_MAIN_COLUMN_CLASS}`}
      >
        <h1 className="text-lg font-semibold">
          {t('CONVERSATION_UNAVAILABLE', { defaultValue: 'Conversation unavailable' })}
        </h1>
        <p className="max-w-md text-sm text-muted-foreground">
          {t('SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN', {
            defaultValue: 'Something Went Wrong, Please Try Again',
          })}
        </p>
        <Button variant="outline" onClick={() => navigate(backTo)}>
          {t('BACK_TO_CHAT')}
        </Button>
      </div>
    </div>
  );
}
